<template>
        <b-button variant="primary">{{ currentField.buttonText }}</b-button>
</template>

<script>
  export default {
    name: 'Button',
    props: ['currentField']
  }
</script>
